module.exports = __webpack_public_path__ + "img/img-5.7bd2fe7a.png";